module.exports = __webpack_public_path__ + "img/p_13_s.a387284e.png";